import Icon from 'components/Icon';
import Text from 'components/Text';
import { useRelativeTimeFormatter } from 'hooks/format';
import type { Question } from 'models/api';
import { is } from 'utils/helpers';

import { ReviewFeedback } from '../Reviews';

interface Props {
	feedbackDoneText: string;
	question: Question;
	reportButtonText: string;
	upvoteButtonText: string;
}

/** A single product question. */
export default function ProductQuestion({
	feedbackDoneText,
	question,
	reportButtonText,
	upvoteButtonText,
}: Props) {
	const { author, date, extract, feedbackUrl, responses, votesUp } = question;
	const formatRelativeTime = useRelativeTimeFormatter();

	return (
		<article className="py-8" aria-label={author}>
			<Text as="p" className="font-bold">
				{author}
			</Text>
			<Text as="pSmall">{formatRelativeTime(date)}</Text>

			<Text as="p" className="my-4">
				{extract}
			</Text>

			{is.arrayWithLength(responses) && (
				<div className="mt-6 space-y-4 rounded-md bg-subtle p-4 forced-colors:border">
					{responses.map((response) => (
						<div key={response.answer}>
							<Text as="h4" styleAs="p" className="font-bold">
								<Icon name="j" className="mr-2" />
								{response.name}
							</Text>
							<Text as="pSmall" className="ml-8">
								{response.answer}
							</Text>
						</div>
					))}
				</div>
			)}

			<ReviewFeedback
				className="mt-6"
				feedbackDoneText={feedbackDoneText}
				feedbackUrl={feedbackUrl}
				reportButtonText={reportButtonText}
				upvoteButtonText={upvoteButtonText}
				votesUp={votesUp}
			/>
		</article>
	);
}
ProductQuestion.displayName = 'ProductQuestion';
